import { createColumn, defaultColumns, inputTextField, relationField } from '../_defaults/columns'

export const columns = [
  // TODO: Change this to company so we have a name field to reference
  createColumn({
    label: 'Company',
    field: 'companyId',
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      validation: {
        required: true
      },
      type: 'one',
      localKey: 'companyId',
      namespace: 'company',
      filterIs: 'text-filter'
    })
  }),
  createColumn({
    label: 'Comment',
    field: 'commentText',
    component: inputTextField({ req: true, type: 'textarea' })
  }),
  createColumn({
    label: 'Last Update',
    field: 'lastUpdate',
    type: 'date',
    component: {
      is: 'q-datetime',
      props: {
        type: 'datetime'
      }
    }
  })
].concat(defaultColumns)
